<template>
  <div class="barrage-container">
    <div ref="msgCon" class="msg-con">
      <div v-for="item in msgArr" :key="item.id" :class="(item.barrageType !== 3 && item.barrageType !== 4) ? 'color-barrage' : ''">
        <slot name="msgItem" :item="item">
        </slot>
      </div>
    </div>
    <div class="unread-con" v-show="unread > 0" @click="scrollToUnread">
      {{ unread }}条新消息
    </div>
  </div>
</template>

<script>
  export default {
    name: "Barrage",
    props: {
      msgArr: {
        type: Array,
        default: () => []
      },
      newMsg: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        unread: 0,
        msgCon: null,
        autoScroll: true,
        unReadHeight: 0,
        timeout: null
      }
    },
    watch: {
      msgArr() {
        this.$nextTick(() => {
          /*先停留一秒钟后迅速滑到底部*/
          setTimeout(() => {
            this.scroll()
          }, 1000)
        })
      },
      newMsg(value) {
        this.msgArr.push(value)
        if (!this.autoScroll) {
          this.unread ++
        } else {
          /*只要有新消息进来并且属于自动滚动范畴就执行scroll滚到底部*/
          this.$nextTick(() => {
            this.scroll()
          })
          this.unread = 0
        }
      }
    },
    mounted() {
      this.msgCon = this.$refs.msgCon
      this.msgCon.addEventListener('scroll', (event) => {
        const top = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight
        /*滑动距离底部超过30px才停止自动滚动*/
        if (top > 30) {
          if (!this.timeout) {
            this.timeout = setTimeout(() => {
              clearTimeout(this.timeout)
              this.$emit('dragOperation')
            }, 5000)
          }
          this.autoScroll = false
        } else {
          this.unread = 0
          this.autoScroll = true
        }
      })
    },
    methods: {
      scroll() {
        if (this.autoScroll) {
          if (this.msgCon.scrollTop < this.msgCon.scrollHeight) {
            this.msgCon.scrollTop = this.msgCon.scrollHeight
          }
        }
      },
      scrollToUnread() {
        this.msgCon.scrollTop = this.msgCon.scrollHeight
      }
    }
  }
</script>

<style lang="scss" scoped>
  .barrage-container {
    position: relative;
    margin-bottom: 20px;
  }

  .msg-con {
    width: 100%;
    max-height: 300px;
    min-height: 200px;

    overflow-y: scroll;
    text-align: left;

    .color-barrage:nth-of-type(3n+2) {
      .nickname {
        color: #FFB5B5;
      }
    }

    .color-barrage:nth-of-type(3n+3) {
      .nickname {
        color: #BDE8FF;
      }
    }

    .color-barrage:nth-of-type(3n+4) {
      .nickname {
        color: #FFF8CF;
      }
    }
  }

  .msg-con::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }

  .unread-con {
    position: absolute;
    bottom:  -30px;
    padding: 15px 20px;
    width: fit-content;

    background-color: #fff;
    border-radius: 60px;
    color: #6982FA;
  }
</style>
